/* Occult Odyssey landing page: star field canvas + scroll-reveal.
   Guarded on #oo-stars/.reveal so this is a no-op on every other template,
   since gulp concatenates all assets/js/*.js into one sitewide bundle. */
(function () {
    const canvas = document.getElementById('oo-stars');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let stars = [];

    function resize() {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
    }

    function initStars() {
        stars = [];
        for (let i = 0; i < 180; i++) {
            stars.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                r: Math.random() * 1.2 + 0.2,
                a: Math.random(),
                s: Math.random() * 0.003 + 0.001,
                d: Math.random() > 0.5 ? 1 : -1
            });
        }
    }

    function drawStars() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        stars.forEach(function (star) {
            star.a += star.s * star.d;
            if (star.a > 0.8 || star.a < 0.1) star.d *= -1;
            ctx.beginPath();
            ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(201, 168, 76, ' + star.a + ')';
            ctx.fill();
        });
        requestAnimationFrame(drawStars);
    }

    resize();
    initStars();

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawStars();
    }

    window.addEventListener('resize', function () {
        resize();
        initStars();
    });
})();

/* Scroll reveal for .reveal elements */
(function () {
    const revealEls = document.querySelectorAll('.oo-main .reveal');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
        return;
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {threshold: 0.15});

    revealEls.forEach(function (el) { observer.observe(el); });
})();

/* Newsletter form loading state (Ghost's members-form JS toggles :disabled,
   this just mirrors that onto a class our CSS can key off of) */
(function () {
    const form = document.querySelector('.oo-newsletter-form');
    if (!form) return;

    form.addEventListener('submit', function () {
        form.classList.add('loading');
    });
})();
